import React, { useContext, createContext } from 'react';
import { noop } from 'lodash';

import { ReturnType, useJobs as useJobsInternal } from 'pages/hiring/useJobs';

const initialContext: ReturnType = {
  touchpoints: [],
  size: 0,
  setSize: noop,
  hasMoreRecords: false,
  isLoading: false,
  isLoadingMore: false,
  totalCount: undefined,
  isAPILoading: false,
  getState: () => '',
  selectedState: 0,
  setSelectedState: noop,
  onDelete: () => new Promise(noop),
  onCloseJob: () => new Promise(noop),
  mutateCampaigns: () => new Promise(noop),
};

const JobsContext = createContext<ReturnType>(initialContext);

export const useJobs = (): ReturnType => useContext(JobsContext);

export const HiringProvider: React.FC = ({ children }) => {
  const value = useJobsInternal();

  return <JobsContext.Provider value={value}>{children}</JobsContext.Provider>;
};
